import React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import styles from '../../styles';
import logo from '../../Soltrack Logo.jpg';

const Header = ({ CreditNote }) => (
    <View fixed>
        <View style={styles.Header}>
            <View style={styles.subSectionA}>
                <Image src={logo} style={styles.logo} />
            </View>
            {/* <View style={styles.subSectionB}>
                <Text style={styles.companyName}>{CreditNote.shipFromName}</Text>
                <Text style={styles.smallText}> {CreditNote.address || `${CreditNote.shipFromCity || ''}${CreditNote.shipFromCity && CreditNote.shipFromState ? ', ' : ''}${CreditNote.shipFromState || ''}`} </Text>
                <Text style={styles.smallText}>Phone: {CreditNote.shipFromMobileNo}</Text>
            </View> */}
            <View style={styles.subSectionB}>
                <Text style={styles.companyName}>Soltrack Technologies Pvt Ltd.</Text>
                <Text style={styles.smallText}>Ahmedabad, Gujarat </Text>
                <Text style={styles.smallText}>Phone: 9988776655</Text>
            </View>
        </View>

        <GSTSection CreditNote={CreditNote} />
        <DocSection CreditNote={CreditNote} />
        <BillToSection CreditNote={CreditNote} />
    </View>
);

const GSTSection = ({ CreditNote }) => (
    <View>
        <View style={styles.taxInvoiceRow}>
            <Text style={styles.leftText}>GSTIN No. {CreditNote.shipFromGstNumber || CreditNote.gstNo}</Text>
            <Text style={styles.centerText}>Credit Note</Text>
            <Text style={styles.rightText}>Original for Recipient</Text>
        </View>
    </View>
);

const DocSection = ({ CreditNote }) => (
    <View style={[styles.headerSection2Container, styles.brdrRight, styles.brdrLeft]}>
        <View style={styles.headerSection2Left}>
            <Text>CreditNote No: {CreditNote.invoiceNo}</Text>
            <Text>Challan No: {CreditNote.challanNo}</Text>
            <Text>PO No: {CreditNote.poNo}</Text>
            <Text>State: {CreditNote.shipFromState}</Text>
        </View>
        <View style={styles.headerSection2MiddleLeft}>
            <Text>Date: {CreditNote.date}</Text>
            <Text>State Code: {CreditNote.stateCode}</Text>
        </View>
        <View style={styles.headerSection2MiddleRight}>
            <Text>Transport: {CreditNote.transport}</Text>
            <Text>L.R No: {CreditNote.LrNo}</Text>
            <Text>Veh. No: {CreditNote.vehNo}</Text>
        </View>
        <View style={styles.headerSection2Right}>
            <Text>Date Of Supply: {CreditNote.LrDate}</Text>
            <Text>Place of supply: {CreditNote.shipFromCity}</Text>
        </View>
    </View>
);

const BillToSection = ({ CreditNote }) => (
    <View style={[styles.detailsSectionContainer, styles.brdrRight, styles.brdrLeft]}>
        <View style={styles.detailsSectionLeft}>
            <Text>Billed To:</Text>
            <Text>{CreditNote.companyName}</Text>
            <Text>{CreditNote.shipToAddress || ''}</Text>
            <Text>Your P.O No: {CreditNote.poNo}</Text>
            <Text>State: {CreditNote.shipToState}</Text>
            <Text>State Code: {CreditNote.stateCode}</Text>
        </View>
        <View style={styles.detailsSectionRight}>
            <Text>Ship To: </Text>
            <Text>{CreditNote.companyName}</Text>
            <Text>GSTIN No: {CreditNote.shipToGstNumber}</Text>
            <Text>State: {CreditNote.shipToState}</Text>
            <Text>State Code: {CreditNote.stateCode}</Text>
        </View>
    </View>
);

export default Header;